interface IPeriodSelector {
  isFullWidth?: boolean;
  centralized?: boolean;
  backgroundColor: string;
  buttonColorSchema: { textColor: string; backgroundColor: string, selectedBackgroundColor: string, selectedTextColor: string };
  period: 'week' | 'month' | 'general';
  onChange: (period: 'week' | 'month' | 'general') => void;
}
const PeriodSelector = ({ isFullWidth = false, centralized = false, backgroundColor, buttonColorSchema, period, onChange }: IPeriodSelector) => {
  return (
    <div className={`${isFullWidth ? 'w-full' : 'w-full md:w-2/3'} ${centralized ? 'mx-auto' : ''} flex flex-row items-center ${backgroundColor} rounded-pill`}>
      <button 
        className={`
          w-1/3 rounded-pill 
          ${period === 'week' ? buttonColorSchema.selectedBackgroundColor : buttonColorSchema.backgroundColor} 
          ${period === 'week' ? buttonColorSchema.selectedTextColor : buttonColorSchema.textColor} 
          p-1 text-xs
        `}
        onClick={() => onChange('week')}
      >
        Semana Atual
      </button>
      <button 
        className={`
          w-1/3 rounded-pill 
          ${period === 'month' ? buttonColorSchema.selectedBackgroundColor : buttonColorSchema.backgroundColor} 
          ${period === 'month' ? buttonColorSchema.selectedTextColor : buttonColorSchema.textColor} 
          p-1 text-xs
        `}
        onClick={() => onChange('month')}
      >
        Mês
      </button>
      <button 
        className={`
          w-1/3 rounded-pill 
          ${period === 'general' ? buttonColorSchema.selectedBackgroundColor : buttonColorSchema.backgroundColor} 
          ${period === 'general' ? buttonColorSchema.selectedTextColor : buttonColorSchema.textColor} 
          p-1 text-xs
        `}
        onClick={() => onChange('general')}
      >
        Geral
      </button>
    </div>
  );
};

export default PeriodSelector;